import { colorStrings, mediaQueriesBP } from "@bevco/Utilities/variables";
import { teamCardGroupWidgetStyles as styles } from "@bevco/Widgets/VerndaleBox/TeamCardGroupWidget";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.title = {
    variant: "h2",
};

styles.cardWrapper = {
    css: css`
        ${mediaQueriesBP.maxMD} {
            overflow: hidden;
            width: 100%;

            & > [class*="Wrapper-"] {
                margin-left: -10px;
                & > * {
                    padding: 0 10px;
                    width: calc(50% + 10px);
                    flex: 0 0 calc(50% + 10px);
                }
            }
        }

        & > [class*="Wrapper-"] {
            display: flex;

            ${mediaQueriesBP.minMD} {
                flex-wrap: wrap;
            }
        }
    `,
};

styles.dotsGroup = {
    css: css`
        ${mediaQueriesBP.maxMD} {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin-top: 30px;
            width: 100%;
        }

        & > .dot {
            background: ${getColor(colorStrings.commonDisabled)};
            border-color: transparent;
            border-radius: 50%;
            cursor: pointer;
            margin-right: 10px;
            padding: 2px 0;
            height: 10px;
            width: 10px;

            &:last-child {
                margin-right: 0;
            }

            &:disabled {
                background: ${getColor(colorStrings.primaryMain)};
            }
        }
    `,
};
